import axios from "axios";
import enviroments from "./enviroments";

const axiosInstance = axios.create({
  baseURL: enviroments.base_url,
});

export default axiosInstance;
